import { Flex, Group, Stack, Text } from '@mantine/core';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { Publication } from '@/module/Author/Publication/model/PublicationTypes';

import { NotEditable } from '@/core/components';

import { useCurrentUser } from '@feature/security';
import { PublishedAtText, Source, WosIndexAt } from '@feature/utils';

interface PublicationTitleGroupProps {
  publication: Publication;
  authorsNo: number;

  editAction: ReactNode;
  deleteAction: ReactNode;

  titlePre?: ReactNode;
}

export function PublicationHeader({
  publication,
  authorsNo,
  editAction,
  deleteAction,
  titlePre,
}: PublicationTitleGroupProps) {
  const { title, publishedAt, source, wosIndexingYear } = publication;
  const { t } = useTranslation();
  const currentUser = useCurrentUser();

  return (
    <Flex
      justify="space-between"
      gap="10px"
    >
      <Stack gap="xs">
        <Group gap="3px">
          {titlePre}
          <Text fw="500">{title}</Text>
        </Group>
        <Group>
          <PublishedAtText
            date={publishedAt}
            size="sm"
            c="dimmed"
          />
          <WosIndexAt year={wosIndexingYear} />
          <Text
            size="sm"
            c="dimmed"
          >
            {authorsNo} {t('articles.noOfAuthors')}
          </Text>
        </Group>
      </Stack>
      <Stack align="flex-end">
        <Source source={source} />
        <Group>
          {source?.type === 'WOS' ? <NotEditable tooltip={t('publications.wosNotEditable')} /> : <>{editAction}</>}
          {(source?.type !== 'WOS' || currentUser.currentRole === 'UNIVERSITY_ADMIN') && <>{deleteAction}</>}
        </Group>
      </Stack>
    </Flex>
  );
}
